/**
 * VDSL port detail — line error-health verdict (vdsl_inventory.error_health)
 * with its 7-day totals and the thresholds that tripped. Shown in the
 * counters section of the port detail page.
 */
import { LocalTime } from "../../lib/datetime";
import { Badge } from "./Badge";
import { vdslErrorTone, type VdslErrors7d } from "../lib/signalTones";

const LABEL: Record<string, string> = {
  good: "no error flag",
  warning: "warning",
  critical: "critical",
  unknown: "not enough data",
};

export function VdslErrorHealthPanel({
  health,
  errors,
  at,
}: {
  health: string | null | undefined;
  errors: VdslErrors7d | null | undefined;
  at: string | null | undefined;
}) {
  if (!health) {
    return (
      <p className="mb-2 text-[11px] text-slate-500">
        Line error flag: not evaluated yet (computed after each counter
        collection and by the daily sweep).
      </p>
    );
  }
  const n = (v: number | undefined) => (v ?? 0).toLocaleString("en-AU");
  const reasons = errors?.reasons ?? [];
  return (
    <div className="mb-2 flex flex-col gap-1 rounded border border-slate-800 bg-slate-950/40 px-3 py-2 text-[11px]">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-slate-400">Line error flag</span>
        <Badge tone={vdslErrorTone(health)}>{LABEL[health] ?? health}</Badge>
        {errors && (
          <span className="font-mono text-slate-400">
            {(errors.days_covered ?? 0).toFixed(1)}d: ES {n(errors.es)} · SES{" "}
            {n(errors.ses)} · UAS {n(errors.uas)} · FEC {n(errors.fec_s)} ·
            retrains {n(errors.retrains)}
          </span>
        )}
        {at && (
          <span className="text-slate-500">
            evaluated <LocalTime iso={at} />
          </span>
        )}
      </div>
      {reasons.length > 0 && (
        <ul
          className={
            health === "critical"
              ? "list-disc pl-5 text-red-300"
              : "list-disc pl-5 text-amber-300"
          }
        >
          {reasons.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
